import React, { useState } from 'react';

import { DetailTile, TileContainer, CarouselContentContainer } from '../Styles';
import {
   BreakpointInPx,
   CustomCardBody,
   CustomNav,
   CustomNavItemSmall,
   CustomNavLink,
   Description,
   ResponsiveMaxWidthContainer,
   SimpleHorizontalSeparator,
   StandardContainer,
   ValueText,
} from '../../../../styledComponents/styledComponents';
import { E2E } from '../../../../constants/general';
import TextWithToolTip from '../TextWithToolTip';
import { CustomCarousel } from '../../../common';
import { PropTypes } from 'prop-types';
import { TabContent, TabPane } from 'reactstrap';
import moment from 'moment';

const ALERT_DETAILS_Carousel1 = [
   { name: 'Connection ID', prop: 'connectionId' },
   { name: 'IP', prop: 'ip' },
   { name: 'Server', prop: 'server' },
   { name: 'Provider', prop: 'provider' },
];

const ALERT_DETAILS_Carousel2 = [
   { name: 'Country', prop: 'countryName' },
   { name: 'City', prop: 'city' },
   { name: 'Video - Height', prop: 'height' },
   { name: 'Video - Width', prop: 'width' },
];

const dateSortFn = (c1, c2) => moment.utc(c1.start).valueOf() - moment.utc(c2.start).valueOf();

const ALERT_DETAILS_CONTAINER = [ALERT_DETAILS_Carousel1, ALERT_DETAILS_Carousel2];

function ExpandedAlertCell({ row, mode }) {
   const connections = row.connectionsDetails.sort(dateSortFn);
   const infoProps = row.streamDetails;
   const [selectedConnectionIdx, setSelectedConnectionIdx] = useState(0);

   // Code for Table Hover Expansion - currently unused

   // const tds = document.querySelectorAll('.functional-td');
   // let hoveredOverCellInSeconds = 0;
   // let idCell;
   // tds.forEach((td) => {
   //    if (td.textContent === row.id) idCell = td;
   // });
   // if (idCell) {
   //    const tableRow = idCell.parentNode;

   //    const childWithHighestHoverTime = Array.prototype.reduce.call(
   //       tableRow.querySelectorAll('.functional-td'),
   //       (highestChild, child) => {
   //          let hoverTime = parseInt(child.dataset.hoverTime, 10);
   //          hoverTime = isNaN(hoverTime) ? 0 : hoverTime;
   //          child.dataset.hoverTime = hoverTime;

   //          return hoverTime > parseInt(highestChild.dataset.hoverTime, 10) ? child : highestChild;
   //       },
   //       tableRow.querySelector('.functional-td'),
   //    );
   //    hoveredOverCellInSeconds = childWithHighestHoverTime.dataset.hoverTime;
   // }

   // if (hoveredOverCellInSeconds > 2) {
   //    return;
   // }

   return (
      <ResponsiveMaxWidthContainer
         $mediaMaxWidthInPx={mode === E2E ? BreakpointInPx.xxxl : BreakpointInPx.md}
         $containerMaxWidthInPx={650}
      >
         {connections.length > 1 ? (
            <CustomCardBody>
               <small className='d-block text-center text-muted mb-1'>Top 10 Connections</small>
               <SimpleHorizontalSeparator spacePx={8} border='1px solid #dee2e6' />
               <CustomNav fill={false} pills={true}>
                  {connections.map((connection, idx) => (
                     <CustomNavItemSmall key={`serverTab_${idx}`}>
                        <CustomNavLink
                           active={idx === selectedConnectionIdx}
                           onClick={() => setSelectedConnectionIdx(idx)}
                        >
                           {`Connection ${idx + 1}`}
                        </CustomNavLink>
                     </CustomNavItemSmall>
                  ))}
               </CustomNav>
               <TabContent activeTab={selectedConnectionIdx}>
                  {connections.map((connection, idx) => (
                     <TabPane tabId={idx} key={`serverTabPane_${idx}`}>
                        <CustomCarousel>
                           {ALERT_DETAILS_CONTAINER.map((details, idx) => (
                              <CarouselContentContainer key={`alertDetails_${idx}`} pTopPx={0}>
                                 <StandardContainer $paddingPx={20}>
                                    <TileContainer gapPx={20} isFullScreen={mode !== E2E}>
                                       {details.map(({ name, prop }) => (
                                          <DetailTile key={prop} gapPx={20}>
                                             <Description marginLeftPx={0}>{name}</Description>
                                             <ValueText>
                                                {connection[prop] ? (
                                                   <TextWithToolTip
                                                      text={connection[prop]}
                                                      idName={prop}
                                                      maxLength={prop === 'server' ? 30 : undefined}
                                                   />
                                                ) : (
                                                   '-'
                                                )}
                                             </ValueText>
                                          </DetailTile>
                                       ))}
                                    </TileContainer>
                                 </StandardContainer>
                              </CarouselContentContainer>
                           ))}
                        </CustomCarousel>
                     </TabPane>
                  ))}
               </TabContent>
            </CustomCardBody>
         ) : (
            <CustomCarousel>
               {ALERT_DETAILS_CONTAINER.map((details, idx) => (
                  <CarouselContentContainer key={`alertDetails_${idx}`} pTopPx={0}>
                     <StandardContainer $paddingPx={20}>
                        <TileContainer gapPx={20} isFullScreen={mode !== E2E}>
                           {details.map(({ name, prop }) => (
                              <DetailTile key={prop} gapPx={20}>
                                 <Description marginLeftPx={0}>{name}</Description>
                                 <ValueText>
                                    {infoProps[prop]?.length > 0 ? (
                                       <TextWithToolTip
                                          text={infoProps[prop].join(', ')}
                                          idName={prop}
                                          maxLength={prop === 'server' ? 30 : undefined}
                                       />
                                    ) : (
                                       '-'
                                    )}
                                 </ValueText>
                              </DetailTile>
                           ))}
                        </TileContainer>
                     </StandardContainer>
                  </CarouselContentContainer>
               ))}
            </CustomCarousel>
         )}
      </ResponsiveMaxWidthContainer>
   );
}

ExpandedAlertCell.propTypes = {
   row: PropTypes.shape({
      connectionsDetails: PropTypes.array,
      streamDetails: PropTypes.shape({
         connectionId: PropTypes.arrayOf(PropTypes.string),
         provider: PropTypes.arrayOf(PropTypes.string),
         city: PropTypes.arrayOf(PropTypes.string),
         countryName: PropTypes.arrayOf(PropTypes.string),
         countryCode: PropTypes.arrayOf(PropTypes.string),
         height: PropTypes.arrayOf(PropTypes.string),
         width: PropTypes.arrayOf(PropTypes.string),
         ip: PropTypes.arrayOf(PropTypes.string),
         server: PropTypes.arrayOf(PropTypes.string),
      }),
      type: PropTypes.string,
   }),
   mode: PropTypes.string,
};

export default ExpandedAlertCell;
